import { useEffect } from "react";

export const useModalScrollLock = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add("modalOpen");
      document.body.classList.add("modalOpen");
    } else {
      document.documentElement.classList.remove("modalOpen");
      document.body.classList.remove("modalOpen");
    }

    return () => {
      document.documentElement.classList.remove("modalOpen");
      document.body.classList.remove("modalOpen");
    };
  }, [isOpen]);
};
